/**
 * Creates a CSS media query based on the breakpoint arguments provided
 *
 * @param {string} type One of 'above' or 'below'
 * @param {string} value Can be a css size value ('300px') or a theme breakpoint key ('lg')
 * @param [theme] A theme that matches the shape of somosTheme from this library
 *
 * @returns {string} CSS media query
 */
var createBreakpoint = function createBreakpoint(type, value) {
  var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var breakpoints = theme.breakpoints || {};
  var queryValue = breakpoints[value] || value;

  if (type === 'above') {
    return "@media (min-width: ".concat(queryValue, ")");
  }

  return "@media (max-width: ".concat(queryValue, ")");
};

export { createBreakpoint };